export default __webpack_public_path__ + "static/media/buildBubble.3b3a564d.png";